export const DELETE_CREDIT_CARD_MODAL = 'DELETE_CREDIT_CARD_MODAL';
